import { DEAL_TYPE_ID, ORDER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
export const useHasBoardSettingsTab = objectTypeId => {
  return objectTypeId === DEAL_TYPE_ID || objectTypeId === ORDER_TYPE_ID;
};